<template>
  <vSelect ref="vSelect" v-bind="$attrs" v-on="$listeners" @close="handleOptionSelected">
    <div slot="no-options">{{ $t('SEARCH_SELECT.NO_OPTIONS') }}</div>
  </vSelect>
</template>

<script>
import vSelect from 'vue-select';

export default {
  name: 'SearchSelect',
  components: { vSelect },
  inheritAttrs: false,
  methods: {
    handleOptionSelected() {
      // Trigger blur event after selecting an option in order to hide mobile keyboard
      const searchInput = this.$refs.vSelect?.$el.querySelector('input[type=search]');
      if (searchInput) searchInput.blur();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';
@import '~vue-select/dist/vue-select.css';

.v-select {
  @include font('DS-200');

  ::v-deep {
    .vs__search {
      line-height: 2;
    }

    .vs__dropdown-toggle {
      height: 56px;
      padding: $sp-s;
      border-color: getShade($quaternary-color, 50);
      border-radius: unset;
    }

    .vs__selected,
    .vs__dropdown-option {
      color: $primary-color;
    }

    .vs__clear path,
    .vs__open-indicator path {
      fill: $primary-color;
    }

    .vs__dropdown-option--highlight {
      background: getShade($quaternary-color, 40);
    }

    .vs__selected-options {
      max-height: 44px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
